// Which contact attributes belong to "Seguimiento · UTM".
//
// The account can flag a definition as `tracking_attribute`; on top of that
// we treat the usual campaign keys (utm_*, click ids, campaign ids, landing)
// as tracking even when the flag was never set, so they land in the UTM card
// instead of the generic attributes list. Works with the raw API record
// (`attribute_key`, `tracking_attribute`) and the camelCased store record.
const TRACKING_KEY_PATTERN =
  /^utm_|clid$|campaign|campana|campaña|secondary_content|landing/i;

export const attributeKeyOf = record =>
  record?.attributeKey ?? record?.attribute_key ?? '';

export const isTrackingAttribute = record => {
  if (!record) return false;
  if (record.trackingAttribute || record.tracking_attribute) return true;
  return TRACKING_KEY_PATTERN.test(attributeKeyOf(record));
};

// Short labels like the mockup (Fuente, Medio, Campaña…); anything else
// keeps its display name without the "UTM" prefix.
const TRACKING_LABELS = {
  utm_source: 'Fuente',
  utm_medium: 'Medio',
  utm_campaign: 'Campaña',
  utm_content: 'Contenido',
  utm_term: 'Término',
  utm_id: 'UTM ID',
  campaign_id: 'ID campaña',
  id_campana: 'ID campaña',
  id_campania: 'ID campaña',
  campaign_code: 'Código campaña',
  landing: 'Landing',
  landing_page: 'Landing',
  secondary_content: 'Landing',
  gclid: 'Gclid',
  fbclid: 'Fbclid',
  ttclid: 'Ttclid',
};

export const trackingLabel = (key, displayName = '') =>
  TRACKING_LABELS[key] ||
  String(displayName || key)
    .replace(/^utm[\s_]+/i, '')
    .replace(/^\w/, c => c.toUpperCase());

// Offered when the account has no tracking attribute at all.
export const DEFAULT_TRACKING_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_id',
  'landing_page',
];
